import { useState } from 'react';
import CashFlowChartContainer from '@/components/analyses/cashFlows/CashFlowChartContainer';
import AnalysisBox from '@/components/core/AnalysisBox';
import AnalysisContainer from '@/components/core/AnalysisContainer';
import CashFlowDataGrid from '@/components/datagrids/CashFlowDataGrid';
import { useCashFlows } from '@/stores/systemAnalysisStore';

const DEFAULT_PLOT = 'After Tax Post Depreciation Cash Flow';

const CashFlowResult = () => {
  const { label = '', cash_flows: cashFlows } = useCashFlows();
  const plottable = cashFlows?.filter(result => result.plottable);
  const plotColumnOptions = plottable?.map(result => ({
    value: `${result.category[0]}-${result.category[1]}`,
    label: `${result.category[0]} - ${result.category[1]}`,
  }));

  const [plotColumn, setPlotColumn] = useState(null);

  const activePlotColumn = plotColumnOptions?.some(o => o.value === plotColumn)
    ? plotColumn
    : (plotColumnOptions?.[0]?.value ?? DEFAULT_PLOT);

  if (!cashFlows) {
    return null;
  }
  return (
    <AnalysisContainer title={label} className="gap-3">
      <AnalysisBox>
        <CashFlowChartContainer data={cashFlows} label={label} plotColumn={activePlotColumn} />
      </AnalysisBox>

      {plotColumnOptions?.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 py-3">
          <label htmlFor="plotColumn" className="text-xs font-semibold">
            Change Graph
          </label>
          <select
            id="plotColumn"
            name="plotColumn"
            value={activePlotColumn}
            onChange={e => setPlotColumn(e.target.value)}
            className="select select-xs select-bordered w-full max-w-xs truncate"
          >
            {plotColumnOptions.map((option, index) => (
              <option key={`${index}-${option.value}`} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <AnalysisBox>
        <CashFlowDataGrid data={cashFlows} />
      </AnalysisBox>
    </AnalysisContainer>
  );
};

export default CashFlowResult;
